'use client';

import { Shield } from 'lucide-react';
import { useAppRouter } from '~/hooks';

export default function PrivacyPage() {
  const router = useAppRouter();

  return (
    <>
      <div className="max-w-4xl mx-auto px-4 py-16">
        <div className="mb-8">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center">
              <Shield className="w-6 h-6 text-primary" />
            </div>
            <h1 className="text-foreground">Privacy Policy</h1>
          </div>
          <p className="text-foreground-secondary">
            Last updated: December 5, 2025
          </p>
        </div>

        <div className="prose prose-slate max-w-none">
          <section className="mb-8">
            <h2 className="text-foreground mb-4 font-bold">1. Introduction</h2>
            <p className="text-foreground-secondary mb-4">
              Welcome to Leadbunker (&quot;we,&quot; &quot;our,&quot; or
              &quot;us&quot;). We respect your privacy and are committed to
              protecting your personal data. This privacy policy will inform you
              about how we look after your personal data when you visit our
              website and use our services.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-foreground mb-4 font-bold">
              2. Information We Collect
            </h2>
            <p className="text-foreground-secondary mb-4">
              We may collect, use, store and transfer different kinds of
              personal data about you:
            </p>
            <ul className="list-disc pl-6 text-foreground-secondary space-y-2 mb-4">
              <li>Identity Data: first name, last name, username</li>
              <li>Contact Data: email address, telephone numbers</li>
              <li>
                Technical Data: IP address, browser type and version, time zone
                setting, browser plug-in types and versions, operating system
                and platform
              </li>
              <li>
                Usage Data: information about how you use our website and
                services
              </li>
              <li>
                Marketing and Communications Data: your preferences in receiving
                marketing from us
              </li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-foreground mb-4 font-bold">
              3. How We Use Your Information
            </h2>
            <p className="text-foreground-secondary mb-4">
              We will only use your personal data when the law allows us to.
              Most commonly, we will use your personal data in the following
              circumstances:
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-foreground mb-4 font-bold">4. Data Security</h2>
            <p className="text-foreground-secondary mb-4">
              We have put in place appropriate security measures to prevent your
              personal data from being accidentally lost, used or accessed in an
              unauthorized way, altered or disclosed. We use 256-bit encryption
              for all data transmission and storage.
            </p>
            <p className="text-foreground-secondary mb-4">
              Importantly, we do not store any scraped data on our servers. All
              scraping operations are performed locally, and the results are
              only accessible to you.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-foreground mb-4 font-bold">
              5. Data Retention
            </h2>
            <p className="text-foreground-secondary mb-4">
              We will only retain your personal data for as long as necessary to
              fulfill the purposes we collected it for, including for the
              purposes of satisfying any legal, accounting, or reporting
              requirements.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-foreground mb-4 font-bold">
              6. Your Legal Rights
            </h2>
            <p className="text-foreground-secondary mb-4">
              Under certain circumstances, you have rights under data protection
              laws in relation to your personal data, including the right to:
            </p>
            <ul className="list-disc pl-6 text-foreground-secondary space-y-2 mb-4">
              <li>Request access to your personal data</li>
              <li>Request correction of your personal data</li>
              <li>Request erasure of your personal data</li>
              <li>Object to processing of your personal data</li>
              <li>Request restriction of processing your personal data</li>
              <li>Request transfer of your personal data</li>
              <li>Right to withdraw consent</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-foreground mb-4 font-bold">
              7. Third-Party Services
            </h2>
            <p className="text-foreground-secondary mb-4">
              We do not share your personal data with third parties except as
              necessary to provide our services or as required by law. We may
              use third-party service providers to help us operate our business
              and the website or administer activities on our behalf.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-foreground mb-4 font-bold">8. Cookies</h2>
            <p className="text-foreground-secondary mb-4">
              Our website uses cookies to distinguish you from other users. This
              helps us to provide you with a good experience when you browse our
              website and also allows us to improve our site.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-foreground mb-4 font-bold">
              9. Changes to This Privacy Policy
            </h2>
            <p className="text-foreground-secondary mb-4">
              We may update our Privacy Policy from time to time. We will notify
              you of any changes by posting the new Privacy Policy on this page
              and updating the &quot;Last updated&quot; date at the top of this
              Privacy Policy.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-foreground mb-4 font-bold">10. Contact Us</h2>
            <p className="text-foreground-secondary mb-4">
              If you have any questions about this Privacy Policy, please
              contact us:
            </p>
            <ul className="list-disc pl-6 text-foreground-secondary space-y-2 mb-4">
              <li>By email: privacy@leadbunker.com</li>
              <li>By visiting our contact page</li>
            </ul>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-card-border">
          <button
            onClick={() => router.push('landing')}
            className="text-primary hover:opacity-80 transition-opacity"
          >
            ← Back to Home
          </button>
        </div>
      </div>
    </>
  );
}
